import { type InsuranceCorporateIdentity } from "../types";

export function BoschLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M255.5 432.842C158.25 432.842 79.1585 353.75 79.1585 256.5C79.1585 159.25 158.25 80.1589 255.5 80.1589C352.75 80.1589 431.841 159.25 431.841 256.5C431.841 353.75 352.75 432.842 255.5 432.842ZM255.5 62.0004C148.162 62 61 149.162 61 256.5C61 363.839 148.162 451 255.5 451C362.838 451 450 363.838 450 256.5C450 149.163 362.838 62.0004 255.5 62.0004Z"
        fill="black"
      />
      <path
        d="M340.645 351.328V310.976V201.62V161.267C367.277 185.075 383.015 219.375 383.015 256.096C383.015 293.22 367.277 327.521 340.645 351.328ZM322.486 292.817H188.918V219.779H322.486V292.817ZM170.356 351.732C143.32 327.924 127.582 293.624 127.582 256.5C127.582 219.375 143.32 185.075 170.356 161.267V351.732ZM335.802 135.038H322.486V201.62H188.918V135.038H175.198C136.056 161.267 109.827 205.655 109.827 256.5C109.827 307.344 136.056 351.732 175.198 377.961H188.918V311.379H322.486V377.961H335.802C375.348 351.732 401.173 307.344 401.173 256.5C401.173 205.656 375.348 161.267 335.802 135.038Z"
        fill="black"
      />
    </svg>
  );
}

export const Bosch: InsuranceCorporateIdentity = {
  id: "bosch",
  name: "Bosch BKK",
  logo: BoschLogo,
  backgroundColor: "#FFFFFF",
  textColor: "#000000",
  wildcard: "bosch",
  type: "statutory",
};
